<template>

  <div class="container">
    <contact-detail :row-data="profile()" prefix="User Profile" :parent-managed="true" />
  </div>

</template>

<script>

import ContactDetail from '@/components/tables/details/ContactDetail'

export default {
  components: {
    ContactDetail
  }
}

</script>



// WEBPACK FOOTER //
// UserProfile.vue?099ebd48